import styled from 'styled-components';
import { AddButtonBlock } from '../../../shared/components/BlockToolbarComponent';
export var RecipeBlockToggle = styled(AddButtonBlock).withConfig({
  displayName: "BlockToolbarComponentstyle__RecipeBlockToggle",
  componentId: "sc-ew3n63-0"
})([""]);